<template>
  <div>
    <el-dialog :width="chooseParam.customWidth" :append-to-body="true" :modal-append-to-body="true" :title="chooseParam.title" :visible.sync="dialogShow" :before-close="reset" top="10vh">
      <el-form inline-message :model="searchList">
        <el-row :gutter="0">
          <el-col :span="8" v-for="item in chooseParam.tableHeader" :key="item.id">
            <el-form-item v-if="item.isSearch=='yes'" :label="item.labelName" :prop="item.propName" :label-width="item.width">
              <el-input size="small" v-model="searchList[item.propName]" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="line-height:39px">
            <el-button v-if="chooseParam.searchBtn" type="primary" @click="searchinfo" size="small" style="margin-left:10px;margin-top:2px">搜索
            </el-button>
            <el-button v-if="chooseParam.searchBtn" type="primary" @click="resetbtn" size="small" style="margin-top:2px">重置
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table v-loading="loading" :data="list" row-key="id" height="400" border stripe highlight-current-row style="width: 100%;" @selection-change="handleSelData" :tree-props="{children: 'children'}">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" width="80">
          <template slot-scope="scope"><span>{{scope.$index+(page.currentPage - 1) * page.pageSize + 1}} </span></template>
        </el-table-column>
        <template v-for="item in chooseParam.tableHeader">
            <el-table-column :key="item.id" v-if="item.isShow=='yes'" :prop="item.propName" :width="item.lableWidth" :label="item.labelName" sortable></el-table-column>
        </template>
      </el-table>
      <el-pagination background class="text-right pt10" @size-change="sizeChange" @current-change="currentChange" :current-page="page.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="page.pageSize" layout="total, sizes, prev, pager, next" :total="page.totalCount"></el-pagination>
      <div slot="footer">
        <el-button size="mini" type="primary" @click="save">确 定</el-button>
        <el-button size="mini" @click="reset">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>


export default {
  name: "dataChoose",
  props: ["chooseParam"],
  data() {
    return {
      basic_url: Config.dev_url,
      list: [],
      //分页显示
      page: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      },
      selData: [],
      dialogShow: false,
      loading: false,
      searchList: {},
      method: "",
    };
  },
  methods: {
    handleSelData(val) {
      this.selData = val;
    },
    sizeChange(val) {
      this.page.pageSize = val;
      this.searchList.page = this.page.currentPage;
      this.searchList.limit = this.page.pageSize;
      this.searchinfo();
    },
    currentChange(val) {
      this.page.currentPage = val;
      this.searchList.page = this.page.currentPage;
      this.searchList.limit = this.page.pageSize;
      this.searchinfo('search');
    },
    handleSelFile(val) {
      this.selFiles = val;
    },
    getListData(opt, parmData) {
      this.searchList = {}
      this.dialogShow = true;
      this.loading = true;
      if (opt == "new") {
        console.log(parmData, "传递条件1111")
        var chooseParam = parmData;
      } else {
        var chooseParam = this.chooseParam;
      }
      var url = Config.dev_url + chooseParam.url;
      console.log(chooseParam.tableHeader)
      for (var i = 0; i < chooseParam.tableHeader.length; i++) {
        if (chooseParam.tableHeader[i].isSearch == "yes") {
          this.$set(this.searchList, chooseParam.tableHeader[i].propName, "");
        }
        //根据筛选标识，添加筛选条件
        if (chooseParam.tableHeader[i].isScreen == "yes") {
          this.$set(this.searchList, chooseParam.tableHeader[i].propName + '_where_not_in', chooseParam.tableHeader[i].targetObject[chooseParam.tableHeader[i].propName]);
        }
      }
      if (chooseParam.search.length != 0) {
        for (var i = 0; i < chooseParam.search.length; i++) {
          this.$set(this.searchList, chooseParam.search[i].name, chooseParam.search[i].val)
        }
      }
      chooseParam.pageSize ? this.page.pageSize = chooseParam.pageSize : this.page.pageSize = 10 //兼容工作票模板页数为20
      var data = {
        page: this.page.currentPage,
        limit: this.page.pageSize
      };
      this.searchList.page = this.page.currentPage
      this.searchList.limit = this.page.pageSize
      // this.searchList = Object.assign(data, this.searchList);
      var searchParm = chooseParam.search;
      for (var i = 0; i < searchParm.length; i++) {
        data[searchParm[i].name] = searchParm[i].val;
      }
      var datatype = !!chooseParam.datatype ? chooseParam.datatype : "";
      this.method = !!chooseParam.method ? chooseParam.method : "post";
      if (this.method == 'get' || this.method == 'GET') {
        data = {
          params: data
        }
      }
      //兼容林post接口url上传参数
      if (!!chooseParam.isSpecialUrl) {
        url = url
          + '?page=' + this.page.currentPage
          + '&limit='
          + this.page.pageSize
        if (!!data.notin) {
          url = url + '&notin=' + data.notin;
          delete data.notin;
        }
        delete data.page;
        delete data.limit;
      }
      this.url = url;
      console.log(data)
      this.$axios[this.method](url, data)
        .then(res => {
          this.list = res.data.data || res.data.subDicts || res.data.datas || res.data;
          this.page.totalCount = res.data.count || res.data.totalElements;
          this.loading = false;
        })
        .catch(err => {
        });
    },
    reset() {
      this.dialogShow = false;
      this.list = [];
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.page.totalCount = 0;
      this.selData = [];
    },
    resetbtn() {

      //判断筛选条件是否存在
      // var Screen = this.chooseParam.tableHeader.some((val)=>{
      //     return val.isScreen == 'yes'
      // })
      //如果存在筛选条件,不清空筛选条件
      // if(Screen){
      //     Object.keys(this.searchList).map((key, item) => {
      //       for(var i=0; i<this.chooseParam.tableHeader.length; i++){
      //           if(this.chooseParam.tableHeader[i].isScreen == 'yes'){
      //               Object.keys(this.searchList).map((key, item) => {
      //                   if (!(key == "page" || key == "limit" || key == this.chooseParam.tableHeader[i].propName + '_where_not_in')) this.searchList[key] = "";
      //               });
      //           }
      //       }
      //     });
      // }else{
      //     Object.keys(this.searchList).map((key, item) => {
      //         if (!(key == "page" || key == "limit" || key.indexOf("_where_not_in") != -1 || key.indexOf("_WHERE_NOT_IN") != -1 )) this.searchList[key] = "";
      //     });
      // }

      for (var i = 0; i < this.chooseParam.tableHeader.length; i++) {
        if (this.chooseParam.tableHeader[i].isSearch == 'yes') {
          this.searchList[this.chooseParam.tableHeader[i].propName] = '';
        }
      }
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.page.totalCount = 0;
      this.searchList.page = 1;
      this.searchList.limit = 10;
      this.searchinfo();
    },
    searchinfo(val) {
      console.log(this.searchList, "搜索条件")
      var data = {
        page: this.page.currentPage,
        limit: this.page.pageSize
      };
      var requestdata = null;
      this.searchList.page = this.page.currentPage
      this.searchList.limit = this.page.pageSize
      if (this.method == 'get' || this.method == 'GET') {
        requestdata = {
          params: this.searchList
        }
      } else {
        requestdata = this.searchList;
      }
      this.$axios[this.method](this.url, requestdata)
        .then(res => {
          this.list =
            res.data.data || res.data.subDicts || res.data.datas || res.data;
          this.loading = false;
          this.page.totalCount = res.data.count || res.data.totalElements;
        })
        .catch(err => {
        });
    },
    save() {
      var isMulti = this.chooseParam.isMulti;
      if (this.selData.length == 0) {
        this.$message({
          message: "请选择数据",
          type: "warning"
        });
      } else if (this.selData.length > 1 && !isMulti) {
        var msg = "不能同时选择多条数据，请重新选择";
        this.$message({
          message: msg,
          type: "warning"
        });
      } else {
        //选定之后执行的操作
        //单选一条数据
        if (this.chooseParam.isMulti == false) {
          //主表数据
          let isMainData = this.chooseParam.tableindex == undefined;
          for (let i = 0; i < this.chooseParam.tableHeader.length; i++) {
            let header = this.chooseParam.tableHeader[i];
            if (header.targetObject != undefined) {
              let value = !!header.propName ? this.selData[0][header.propName] : this.selData[0][this.chooseParam.tableHeader[0].propName];
              if (!!this.chooseParam.fn) {
                this.chooseParam.fn(this.selData[0]);
              }
              if (isMainData) {
                //                  header.targetObject[header.targetAttribute] = value;
                this.$set(header.targetObject, header.targetAttribute, value === undefined ? "" : value);
              } else {
                //                  header.targetObject[this.chooseParam.tableindex][header.targetAttribute] = value;
                this.$set(header.targetObject[this.chooseParam.tableindex], header.targetAttribute, value);
              }
              console.log(value)
              if (!!value) {
                this.$emit("updateChoose", value, header.targetAttribute);
              }
            } else {
              this.$emit("returnChoose", this.selData);
            }
          }
          this.$emit("returnSelectValue",this.selData[0])
        } else {
        }
        //重置页面
        this.reset();
      }
      this.$emit('updateMethods', this.chooseParam)
    }
  }
};
</script>
